import service from '@/store/services/atividades-service';

const state = {
  list: {},
  atividade: {},
  meta: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, atividade) => {
    state.atividade = atividade;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((atividade) => { commit('SET_RESOURCE', atividade); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((atividade) => { commit('SET_RESOURCE', atividade); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((atividade) => { commit('SET_RESOURCE', atividade); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  atividade: state => state.atividade,
  dropdown: (state) => {
    return state.list.map(atividade => ({
      id: atividade.id,
      name: atividade.name
    }));
  }
};

const atividades = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default atividades;
